export var ShuffleAction = /*#__PURE__*/ function(ShuffleAction) {
    ShuffleAction[ShuffleAction["GetShuffleQueueData"] = 1] = "GetShuffleQueueData";
    return ShuffleAction;
}({});
